jQuery(function () {	
	//index
	var banner = new Swiper('.banner .swiper-container',{
		loop:true,
		autoplay : 6000,
		autoplayDisableOnInteraction : false,
		speed : 1000,
		slidesPerView : 1,
		observer:true,
		observeParents:true,
		prevButton:'.banPrev',
		nextButton:'.banNext',
	})
	
	$('.videoPlay').click(function () {
	    console.log($(this).siblings('video'))
	    $('video.video-box').each(function () {
	      $(this)[0].pause();
	      $(this).siblings('.videoPlay').show();
	    })
	    $(this).hide().siblings('video')[0].play();
	    var videoclass = $(this).siblings('video').attr('id');
	    $(this).parents('.wow').css('animation-name','none');
	    clickvideo(videoclass);
	  })
	  /*进度条显示*/
	$('video.video-box').attr('controls', false);//默认进度条隐藏
	function clickvideo(videoclass) {
	  var video = document.getElementById(videoclass);
	  console.log(video)
	  video.controls = false;
	  //使用事件监听方式捕捉事件
	  video.addEventListener("timeupdate", function () {
		var timeDisplay;
		//用秒数来显示当前播放进度
		timeDisplay = Math.floor(video.currentTime);
		//console.log(timeDisplay)
		if (timeDisplay >= 1) {//当视频播放到 4s的时候做处理
		  video.controls = true;//处理代码 显示进度条
		}
	  }, false);
	}
	$(".classic-nav .tab-nav").on("click", function() {
		var _index = $(this).index();
		$(this).addClass("active").siblings(".tab-nav").removeClass("active");
		$(".classic-con .cls-content").eq(_index).addClass("animated fadeInRight").show().siblings(".classic-con .cls-content").hide();
	});

	$(".index-pop-pic .close-btn").on("click", function(){
		$(".index-pop-mask").fadeOut("slow");
		$(".index-pop-pic").fadeOut("slow");
	});
	$(window).scroll(function(){
		let $banner=$(".banner");
		if($banner.length>0){
			var top = $(".banner").offset().top;
			var scrollTop = $(window).scrollTop();
			if(scrollTop > top){
				$(".header").addClass("active");
				$(".to-top").fadeIn("slow");
			}else{
				$(".header").removeClass("active");
				$(".to-top").fadeOut("slow");
			}
		}
	})
	
	function equip(){
	}
	equip();
	$(window).resize(function(){
		equip();
	})
})


//////////////////
// WEBPACK FOOTER
// ./static/js/index.js
// module id = B+pY
// module chunks = 0